export interface BdResourcesInfoMenuConfig {
  showDeleteButton: boolean;
  showEditButton: boolean;
  showShareButton: boolean;
  showPermissionsButton: boolean;
}

export const BD_RESOURCES_INFO_MENU_DEFAULT_CONFIG: BdResourcesInfoMenuConfig =
  {
    showDeleteButton: true,
    showEditButton: true,
    showShareButton: true,
    showPermissionsButton: true,
  };
